import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack gap-3 mb-5" }
const _hoisted_2 = { class: "d-flex flex-column flex-lg-row align-items-stretch align-items-lg-end w-100 w-lg-auto gap-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-filter fs-1" }),
  /*#__PURE__*/_createElementVNode("span", null, "Filtro")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "my-3 text-center" }, "Búsqueda avanzada", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-black my-3" }, "Tipo de búsqueda", -1)
const _hoisted_6 = { class: "d-flex align-items-end flex-wrap gap-2 w-100 w-lg-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-plus fs-2 me-2 text-white" }, null, -1)
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body p-0 overflow-y" }
const _hoisted_10 = { class: "d-flex align-items-center gap-2" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  class: "d-flex flex-column",
  style: {"line-height":"1.25"}
}
const _hoisted_13 = { class: "fw-bold text-primary-emphasis" }
const _hoisted_14 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  class: "text-dark-50 text-hover-primary cursor-pointer",
  style: {"line-height":"1.25"}
}
const _hoisted_17 = { class: "fw-bold text-black" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "text-capitalize" }
const _hoisted_20 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_21 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_22 = { class: "badge badge-secondary fw-normal" }
const _hoisted_23 = { class: "d-flex d-flex align-items-center gap-3" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots-vertical fs-3 px-0 text-hover-primary" }, null, -1)
const _hoisted_26 = { class: "card-footer d-flex justify-content-between align-items-center py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_ModalAddEdit = _resolveComponent("ModalAddEdit")!
  const _component_PayRollDrawer = _resolveComponent("PayRollDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.filter.text,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.text) = $event)),
          class: "w-100 w-md-350px",
          placeholder: "Buscar...",
          clearable: "",
          onKeypress: _withKeys(_ctx.getData, ["enter"]),
          onClear: _ctx.getData,
          "prefix-icon": _ctx.Search
        }, null, 8, ["modelValue", "onKeypress", "onClear", "prefix-icon"]),
        _createVNode(_component_el_popover, {
          placement: "bottom",
          width: 300,
          trigger: "click",
          visible: _ctx.filterPopoverOpen,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterPopoverOpen) = $event)),
          teleported: false
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, { class: "text-successd-flex align-items-center" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5,
            _createVNode(_component_el_select, {
              modelValue: _ctx.filter.option,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.option) = $event)),
              class: "w-100",
              placeholder: "Select"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeFilter, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["visible"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.openModalRegister,
          class: "w-100 w-md-auto w-lg-auto"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.t('register')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_ctx.listPersons.length>0)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _ctx.listPersons,
              "table-layout": "auto",
              "scrollbar-always-on": false,
              class: "fs-",
              "header-cell-class-name": "fw-bolder bg-light-primary text-uppercase text-center text-fprimary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "idperson",
                  label: "ID",
                  width: "120",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('country'),
                  width: "150",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: `${_ctx.REPO}/${row?.country?.flag}`,
                        alt: `${row?.country?.name}`,
                        class: "w-26px h-20px border rounded"
                      }, null, 8, _hoisted_11),
                      _createElementVNode("span", null, _toDisplayString(row?.country?.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "docnumber",
                  label: _ctx.t('document'),
                  width: "120"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(row.docnumber), 1),
                      (row?.document_type?.name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(row?.document_type?.name), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "persona",
                  label: _ctx.t('participant')
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", {
                      class: "d-flex align-items-center gap-2",
                      onClick: ($event: any) => (_ctx.openModalDetails(row))
                    }, [
                      _createVNode(_component_el_avatar, {
                        size: "default",
                        fit: "contain",
                        src: `${_ctx.REPO}/${row.photo?.ruta}`,
                        class: _normalizeClass('border')
                      }, null, 8, ["src"]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(row.firstname), 1),
                        _hoisted_18,
                        _createElementVNode("span", _hoisted_19, _toDisplayString(row.lastname + ' ' + row.surname), 1)
                      ])
                    ], 8, _hoisted_15)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "gender",
                  label: _ctx.t('gender'),
                  width: "100",
                  align: "center",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.gender == 'M')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(scope.row.gender), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(scope.row.gender), 1))
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "birthday",
                  label: "Nacimiento",
                  width: "150",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.moment(row.birthday).format("DD/MM/YYYY")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "created_at",
                  label: _ctx.t('registered'),
                  width: "180",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.moment(row.created_at).format("DD/MM/YYYY H:mm:ss")), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  width: "120",
                  label: _ctx.t('options'),
                  fixed: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: _ctx.t('delete'),
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: "bi bi-trash fs-2 text-hover-danger cursor-pointer",
                            onClick: ($event: any) => (_ctx.onDelete(row))
                          }, null, 8, _hoisted_24)
                        ]),
                        _: 2
                      }, 1032, ["content"]),
                      _createVNode(_component_el_dropdown, { trigger: "click" }, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (_ctx.openDrawerPayroll(row))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('home3')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _ctx.loading]
            ])
          : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              description: "No se encontrarón registros"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.getData
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Volver a intentar")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })), [
              [_directive_loading, _ctx.loading]
            ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("span", null, [
          _createTextVNode("Total "),
          _createElementVNode("b", null, _toDisplayString(_ctx.totalItems), 1)
        ]),
        (_ctx.listPersons.length>0)
          ? (_openBlock(), _createBlock(_component_el_pagination, {
              key: 0,
              "current-page": _ctx.currentPage,
              "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentPage) = $event)),
              "page-size": _ctx.pageSize,
              "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageSize) = $event)),
              "page-sizes": [10, 50, 100, 200],
              "pager-count": 3,
              size: "small",
              background: "",
              layout: "sizes, prev, pager, next",
              total: _ctx.totalItems,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalAddEdit, {
      ref: "modalAddEditRef",
      onOnPersonResponse: _ctx.onPersonResponse
    }, null, 8, ["onOnPersonResponse"]),
    _createVNode(_component_PayRollDrawer, {
      ref: "PayrollDrawerRef",
      "row-item": _ctx.rowItem
    }, null, 8, ["row-item"])
  ], 64))
}